import { QuoteEventType } from '@features/invoices/enums/quoteEventType'
import type { QuoteEvent } from '@features/invoices/types/quotes/quoteEvent'
import type { RelatedInvoice } from '@features/invoices/types/relatedInvoice'

import { quoteBillingStageToTranslationKey } from '../constants/quoteBillingStageToTranslationKey'
import { quoteStatusToTranslationKey } from '../constants/quoteStatusToTranslationKey'

export const getQuoteTimelineStatusTranslationKey = (
  event: QuoteEvent,
  relatedInvoices?: Pick<RelatedInvoice, 'invoiceId' | 'billingStage'>[],
): string => {
  const defaultTranslationKey = quoteStatusToTranslationKey[event.eventType] ?? event.eventType

  if (event.eventType !== QuoteEventType.DocumentInvoiced) {
    return defaultTranslationKey
  }

  const relatedInvoice = relatedInvoices?.find((invoice) => invoice.invoiceId === event.eventData.approvedInvoiceId)

  if (!relatedInvoice?.billingStage) {
    return defaultTranslationKey
  }

  return quoteBillingStageToTranslationKey[relatedInvoice.billingStage] ?? defaultTranslationKey
}
